import { useTranslation } from 'react-i18next';
import DialogBox from '../../../core-components/theme/components/DialogBox/DialogBox';
import { LogbookTemplateEditData } from '../types/loogBookTypes';
import LogbookTemplateModalContent from './LogbookTemplateModalContent';

interface AddLogbookTemplateModalProps {
    open: boolean;
    onClose: () => void;
    initialData?: LogbookTemplateEditData;
}

export default function AddLogbookTemplateModal({
    open,
    onClose,
    initialData,
}: AddLogbookTemplateModalProps) {
    const { t } = useTranslation();
    const title = initialData?.logbookTemplateId
        ? t('logbook.templates.editLogbookTemplate', 'Edit Logbook Template')
        : t('logbook.templates.addLogbookTemplate', 'Add Logbook Template');

    return (
        <DialogBox open={open} onClose={onClose} title={title} width='40%' height='75vh' maxHeight='75%' maxWidth="700px">
            {open && (
              <LogbookTemplateModalContent 
                key={initialData?.logbookTemplateId || 'new'}
                onClose={onClose} 
                initialData={initialData} 
              />
            )}
        </DialogBox>
    );
}
